import {
    ICorporationResponse,
    ICurrentUserResponse,
    ILocationResponse,
} from '@kcftech/prometheus-client';
import { User } from 'configcat-react';

type BuildConfigCatUserOptions = Readonly<{
    user: ICurrentUserResponse;
    corporation?: ICorporationResponse;
    location?: ILocationResponse;
}>;

/**
 * Builds a ConfigCat `User` from the app's current user identity and
 * optional route-level corporation/location context. The returned object
 * is used by `setDefaultUser` so that all `useFeatureFlag` evaluations
 * include targeting attributes like role, corporation, and location.
 */
export function buildConfigCatUser({
    user,
    corporation,
    location,
}: BuildConfigCatUserOptions): User {
    return new User(user.Id, user.Email, undefined, {
        role: user.ApplicationRole,
        corporationIds: user.Corporations.map((c) => c.CorporationId),
        locationIds: user.Locations.map((l) => l.LocationId),
        ...(corporation && {
            currentCorporationId: corporation.Id,
        }),
        ...(location && {
            currentLocationId: location.Id,
        }),
    });
}
